module.exports = __webpack_public_path__ + "static/media/restaurant-bg.f8b4e03d.png";